export const slugs = {
    paymentMethodsSlugs: {
        contract: 'contracto',
        reservation: 'reserva',
        banktransfer: 'transferencia',
        atm: 'multicaixa',
        money: 'numerario',
    },
    userRoles: {
        student: 'student',
        client: 'client',
        administrator: 'administrator',
        trainer: 'trainer',
    },
    courseTypes: {
        online: 'online',
        onsite: 'presencial',
    },
    erpCompanyGroups: ['CNGN', 'CNGE', 'CGSB'],
    erpIndividualGroups: ['ZCPN', 'ZCPE'],
    enrollmentStatus: {
        registered: 'registered',
        enrolled: 'enrolled',
        canceled: 'canceled',
        withdrawal: 'withdrawal',
    },
    classesStatus: {
        opened: 'opened',
        closed: 'closed',
        canceled: 'canceled',
        concluded: 'concluded',
    },
    ordersStatus: {
        pending: 'pendente',
        awaitingPayment: 'aguarda-pagamento',
        awaitingSatisfaction: 'aguarda-satisfacao',
        finished: 'finalizada',
        returned: 'devolvida',
        canceled: 'cancelada',
    },
}
